<!-- タイトルバー メインカラー -->
<template>
  <div class="crly-a-common-title-bar-main">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonTitleBarMain",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/titleBarMain.scss";
</style>
